// Angular Imports
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Output,
	booleanAttribute,
	effect,
	input,
	signal,
	viewChild,
} from '@angular/core'
// Angular Material Imports
import { MatRippleModule } from '@angular/material/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
// Shared Imports
import { EButtonColor, EColor, TTooltipPosition } from '@shared/models'
// Thirdparty Imports
import { Observable, throttleTime, fromEvent } from 'rxjs'

@Component({
	standalone: true,
	imports: [MatRippleModule, MatTooltipModule, MatProgressSpinnerModule],
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
	readonly EButtonColor = EButtonColor

	color = input<keyof typeof EButtonColor>()
	isOutline = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	hasIcon = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	isDisabled = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	isFull = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	hasTooltip = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	buttonSmall = input<boolean>(true)
	tooltipLabel = input<string>('')
	tooltipPosition = input<TTooltipPosition>('below')
	loading = input<boolean, boolean | string>(false, { transform: booleanAttribute })
	isLoading = signal<boolean>(false)

	@Output() clicked = new EventEmitter<void>()

	buttonElement = viewChild<ElementRef>('button')
	#buttonChanges!: Observable<any>

	disabledInner = signal<boolean>(false)
	readonly #disableTime: number = 300

	constructor() {
		effect(() => {
			// console.log('button', this.buttonComponent()?.nativeElement)
			const buttonElement = this.buttonElement()?.nativeElement
			if (buttonElement) {
				this.#buttonChanges = fromEvent(buttonElement, 'click')
				this.#buttonChanges.pipe(throttleTime(this.#disableTime)).subscribe({
					next: () => {
						if (!this.loading()) {
							this.isLoading.set(true)
						}
						this.disabledInner.set(true)
						this.clicked.emit()

						setTimeout(() => {
							this.disabledInner.set(false)
							this.isLoading.set(false)
						}, this.#disableTime)
					},
				})
			}
		})
	}
}
